var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTplDesignMarkEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 188.5 232.1",
    style: {
      enableBackground: "new 0 0 188.5 232.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#39B54A;}\r\n\t.st1{fill:#F7931E;}\r\n\t.st2{fill:#5DD8D8;}\r\n\t.st3{fill:#362229;}\r\n\t.st4{fill:#006837;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.2,21.1L4.4,104.9v4.6C4.3,124.3,6.7,139,11.7,153l76.5-76.5V21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.6,3v217.5c33.4-9.6,57.3-28.1,71.1-55.1c8.3-16.2,12.7-35.5,12.7-55.8V3H100.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "88.2,3.5 88.2,3 4.3,3 4.3,87.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.2,28.6v5.9h-13.4v16.7h-6.6V34.5h-13.4v-5.9H153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.3,75.5c8.2,0,10.9,3.6,10.9,8.5l0,0c0,4.9-2.6,8.5-10.9,8.5h-17.5V98h-6.4V75.5H145.3z M149.8,84 c0-1.8-1.1-2.7-4.5-2.7h-17.5v5.4h17.5C148.7,86.7,149.8,85.8,149.8,84L149.8,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128,122.3v16.5h24.1v6.1h-30.8v-22.6L128,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.2,221V94.1l-71.2,71.1C28.2,187.2,49.1,209.4,88.2,221z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.3,221v1.5h-2.5v6.7H142v-6.7h-2.5V221H146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.8,221l1.9,5.7h0l1.8-5.7h2.6v8.3h-1.7v-5.8h0l-2,5.8H151l-2-5.8h0v5.8h-1.7V221H149.8z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTplDesignMarkEarth);
export default __webpack_public_path__ + "static/media/tpl_design_mark_earth.323f794e10a2615e36205ff3f5cf5e35.svg";
export { ForwardRef as ReactComponent };